import { DayOfTheWeekRange } from 'cron-parser/types';

export function addDayOfWeekToExpression(
  expression: string,
  dayOfWeek: DayOfTheWeekRange[],
): string {
  if (!dayOfWeek.length) {
    return expression;
  }

  const expressionItems = expression.split(' ');

  if (!expressionItems?.[4]) {
    return expression;
  }

  const sortedDayOfWeek = [...dayOfWeek].sort();

  expressionItems.pop();
  expressionItems.push(sortedDayOfWeek.join(','));

  return expressionItems.join(' ');
}
